// extracted by mini-css-extract-plugin
export default {"logoEditorContainer":"OrganizationOnboardingStepTeam-module__logoEditorContainer--cg8VU"};